import React, { FC } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { TicketIcon } from 'app/design-system/components/MulticolorIcons';
import { useTranslation } from 'app/lang';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';

import Entries from './components/Entries';
import OneClickBet from './components/OneClickBet';
import { selectBets } from './selectors/entries';
import { selectOneClickBetActive, selectSettingsActive } from './selectors/preferences';

import dictionary from './BetSlip.dictionary.json';

import styles from './BetSlip.module.scss';

// ---

type StoreProps = {
  loggedIn: boolean;
  oneClickBet: boolean;
  settingsActive: boolean;
  entriesSize: number;
};

const BetSlipContent: FC<StoreProps> = ({
  oneClickBet,
  entriesSize,
  settingsActive,
}) => {
  const { t } = useTranslation();

  const renderBetSlipEntries = () => {
    if (entriesSize > 0) {
      return (
        <Entries />
      );
    }

    return (
      <p className={styles.emptyBetSlip}
         data-test="betSlip-emptyBetSlip">
        <TicketIcon />
        <span>{t(dictionary.emptyBetSlip)}</span>
      </p>
    );
  };

  return (
    <div className={styles.betSlipContent}
         data-test="betSlip-content">
      {settingsActive && entriesSize > 0 && (
        <div className={styles.backdrop}
             data-test="betSlip-backdrop" />
      )}
      {oneClickBet ? (
        <OneClickBet />
      ) : renderBetSlipEntries()}
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => {
  const entriesSize = selectBets(state).size;

  return {
    entriesSize,
    loggedIn: selectIsLoggedIn(state),
    oneClickBet: selectOneClickBetActive(state),
    settingsActive: selectSettingsActive(state),
  };
};

export default connect(mapStateToProps)(BetSlipContent);
